// src/pages/OurPricesPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Button from "../components/Button";
import { Box } from "@mui/material";
import "./OurPricesPage.css";
import PageHeader from '../components/PageHeader';

const OurPricesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateDeposit = () => {
    navigate("/create");
  };

  return (
    <Layout>
      <PageHeader 
        title={t("pricing.title")} 
        subtitle={t("pricing.subtitle")} 
      />
      <Card title={"Simple, Basique 😍"}>
        <Box className="pricing-content">
          <p>
            <span className="pricing-label">{t("pricing.creationLabel")}</span>
          </p>
          <p>
            <span className="pricing-value">{t("pricing.creationValue")}</span>
          </p>
          <p>
            <span className="pricing-label">{t("pricing.releaseLabel")}</span>
          </p>
          <p>
            <span className="pricing-value">{t("pricing.releaseValue")}</span>
          </p>
          <p>
            <span className="pricing-label">{t("pricing.collectionLabel")}</span>
          </p>
          <p>
            <span className="pricing-value small">{t("pricing.collectionValue")}</span>
          </p>
        </Box>
        <div className="pricing-cta">
          <Button label={t("pricing.cta")} onClick={handleCreateDeposit} type="button" />
        </div>
      </Card>
    </Layout>
  );
};

export default OurPricesPage;
